<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 8.39258H15.75V3.89258C15.75 3.49475 15.592 3.11322 15.3107 2.83192C15.0294 2.55061 14.6478 2.39258 14.25 2.39258H9.75C9.35218 2.39258 8.97064 2.55061 8.68934 2.83192C8.40804 3.11322 8.25 3.49475 8.25 3.89258V8.39258H3.75C3.35218 8.39258 2.97064 8.55061 2.68934 8.83192C2.40804 9.11322 2.25 9.49475 2.25 9.89258V14.3926C2.25 14.7904 2.40804 15.1719 2.68934 15.4532C2.97064 15.7345 3.35218 15.8926 3.75 15.8926H8.25V20.3926C8.25 20.7904 8.40804 21.1719 8.68934 21.4532C8.97064 21.7345 9.35218 21.8926 9.75 21.8926H14.25C14.6478 21.8926 15.0294 21.7345 15.3107 21.4532C15.592 21.1719 15.75 20.7904 15.75 20.3926V15.8926H20.25C20.6478 15.8926 21.0294 15.7345 21.3107 15.4532C21.592 15.1719 21.75 14.7904 21.75 14.3926V9.89258C21.75 9.49475 21.592 9.11322 21.3107 8.83192C21.0294 8.55061 20.6478 8.39258 20.25 8.39258ZM20.25 14.3926H15C14.8011 14.3926 14.6103 14.4716 14.4697 14.6122C14.329 14.7529 14.25 14.9437 14.25 15.1426V20.3926H9.75V15.1426C9.75 14.9437 9.67098 14.7529 9.53033 14.6122C9.38968 14.4716 9.19891 14.3926 9 14.3926H3.75V9.89258H9C9.19891 9.89258 9.38968 9.81356 9.53033 9.67291C9.67098 9.53226 9.75 9.34149 9.75 9.14258V3.89258H14.25V9.14258C14.25 9.34149 14.329 9.53226 14.4697 9.67291C14.6103 9.81356 14.8011 9.89258 15 9.89258H20.25V14.3926Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsFirstAid'
})

defineProps({
  fill: {
    type: String,
    default: '#671cc2'
  }
})
</script>
